import { render, staticRenderFns } from "./TsCommonMenu.vue?vue&type=template&id=3a6285e3&scoped=true&"
import script from "./TsCommonMenu.vue?vue&type=script&lang=js&"
export * from "./TsCommonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6285e3",
  null
  
)

export default component.exports